/**
 * Order signature timestamps in the order popup.
 *
 * keyon stores orders.nurssigtimestamp / provsigtimestamp as wall-clock text in its
 * own zone, "YYYY-MM-DD HH:MM:SS". The popup shows that text as stored, without
 * converting it, and a signature made in the popup is stamped with the browser's
 * clock in the same shape until the order is read again. The page assumes no zone:
 * keyon only takes the date from the stamp it is sent and adds its own time.
 */

const STORED = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::\d{2})?$/;

/** "2026-10-12 19:02:27" -> "10/12/2026, 7:02 PM" (no zone conversion); '' for empty; unreadable text as is. */
export function formatSignatureTime(stored) {
  if (stored == null) return "";
  const s = String(stored).trim();
  if (!s) return "";
  const m = STORED.exec(s);
  if (!m) return s;
  const [, y, mo, d, h, mi] = m;
  const hour = Number(h);
  const h12 = hour % 12 === 0 ? 12 : hour % 12;
  return `${mo}/${d}/${y}, ${h12}:${mi} ${hour < 12 ? "AM" : "PM"}`;
}

/** The browser's clock for `now`, in the stored "YYYY-MM-DD HH:MM:SS" shape. */
export function signatureStampNow(now = new Date()) {
  const pad = (n) => String(n).padStart(2, "0");
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} `
    + `${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
}
